/*
* Author : Giridhar Yampalwar
* Funcitonality : Custom drop down select box with search feature inside items.
* Target class 'custom-search-select' in pages and initCustomStateSelect to initialise that control
*/

let firstLoaded = true ;

module.exports = {
    initCustomStateSelect: function (_parentElement) {
        const parentElement = document.querySelector(_parentElement);
        const countryDropdown = parentElement.querySelector('.country-wrapper.countrySelector');
        const countryCodeDropdown = parentElement.querySelector('.countryCodeSelector');

        if (countryDropdown) {
            this.initCoutrySelection(countryDropdown, parentElement);
            this.loadRespectiveState({
                loadedfrom: 'firstload',
                parentElement: parentElement
            });
        }

        if (countryCodeDropdown) {
            this.initCoutryCodeSelection(parentElement, countryCodeDropdown);
        }

        document.querySelectorAll(".custom-search-select").forEach(dropdown => {
            const button = dropdown.querySelector(".dropdown-btn");
            const dropdownMenu = dropdown.querySelector(".dropdown-menu");
            const searchInput = dropdown.querySelector(".dropdown-search");
            const noMatchItem = dropdown.querySelector(".dropdown-list__no-match-found");

            // Remove any previously attached listener to avoid duplicates
            button.replaceWith(button.cloneNode(true));
            const newButton = dropdown.querySelector(".dropdown-btn");

            // Toggle dropdown open/close
            newButton.addEventListener("click", (e) => {
                // Close other dropdowns
                document.querySelectorAll(".custom-search-select").forEach(otherDropdown => {
                    if (otherDropdown !== dropdown) {
                        otherDropdown.querySelector(".dropdown-menu").classList.remove("show");
                        otherDropdown.querySelector(".dropdown-btn").classList.remove("open");
                    }
                });

                // Toggle this dropdown
                const isOpen = dropdownMenu.classList.toggle("show");
                button.classList.toggle("open", isOpen);

                // Focus search input if opened
                if (isOpen) searchInput.focus();
            });

            // Optional: close when clicking outside
            document.addEventListener("click", (e) => {
                if (!dropdown.contains(e.target)) {
                    dropdownMenu.classList.remove("show");
                    button.classList.remove("open");
                }
            });

            // Filter data on input
            searchInput.addEventListener("input", () => {
                const val = searchInput.value.toLowerCase();
                const list = searchInput.parentElement.querySelector(".dropdown-list");

                // Check if list exists and has children
                if (!list || !list.children || list.children.length === 0) return;

                let hasMatch = false;

                Array.from(list.children).forEach(li => {
                    if (li.textContent.toLowerCase().includes(val)) {
                        li.style.display = "";
                        hasMatch = true;
                    } else {
                        li.style.display = "none";
                    }
                });

                // Handle "No match found"
                if (hasMatch) {
                    noMatchItem.style.display = "none";
                    noMatchItem.classList.add('hidden');
                } else {
                    // Remove "No match found" if matches appear
                    noMatchItem.style.display = "";
                    noMatchItem.classList.remove('hidden');
                }
            });
        });
    },
    updateList: function (container, dataList, loadedfrom, parentElement) {
        const dropdownContainer = parentElement.querySelector(container);
        const dropdownBtn = dropdownContainer.querySelector(".dropdown-btn");
        const dropdownMenu = dropdownContainer.querySelector(".dropdown-menu");
        const dropdownMenuSearch = dropdownContainer.querySelector(".dropdown-search");
        const buttonText = dropdownContainer.querySelector(".selected-text");
        const lastSelectedState = dropdownContainer.getAttribute("data-last-selected-text");
        const list = dropdownContainer.querySelector(".dropdown-list");
        const dropdownBtnGhostInput = dropdownContainer.querySelector(".dropdown-btn__ghost-input");

        list.innerHTML = "";

        if (!dataList.length) {
            const empty = document.createElement("li");
            empty.textContent = "No states available";
            empty.style.color = "#888";
            list.appendChild(empty);
            return;
        }

        dataList.forEach(state => {
            const li = document.createElement("li");
            li.textContent = state;
            li.addEventListener("click", () => {
                buttonText.textContent = state;
                dropdownMenu.classList.remove("show");
                dropdownBtn.classList.remove("open");

                if (dropdownBtnGhostInput) {
                    dropdownBtnGhostInput.value = state;
                }
            });
            list.appendChild(li);

            dropdownMenuSearch.classList.remove("hidden");
        });

        if ( loadedfrom == 'countryCodeDropdown' || loadedfrom == 'countryDropdown') {
            buttonText.textContent = "Select State";
            dropdownBtnGhostInput.value = '';
        } else {
            this.resetStateSelectedText(parentElement);
        }

        

    },
    resetStateSelectedText: function (parentElement) {
        const stateDropdown = parentElement.querySelector('.custom-search-select.shipping-state-dropdown');
        const buttonText = stateDropdown.querySelector(".selected-text");
        const dropdownBtnGhostInput = stateDropdown.querySelector(".dropdown-btn__ghost-input");
        const lastSelectedState = stateDropdown.getAttribute("data-last-selected-text");
        const isStageShipping = window.location.href.includes('stage=shipping');

        if (stateDropdown) {
            if (lastSelectedState != 'null' && lastSelectedState != null && lastSelectedState.length > 0 && !isStageShipping) {
                buttonText.textContent = lastSelectedState;
                dropdownBtnGhostInput.value = lastSelectedState;
            } else {

                buttonText.textContent = "Select State";
                dropdownBtnGhostInput.value = '';
            }
        }

    },
    initCoutryCodeSelection: function(parentElement, countryCodeDropdown) {
        const self = this;

        countryCodeDropdown.addEventListener('click', (event) => {
            const item = event.target.closest('.item');

            if (item && countryCodeDropdown.contains(item)) {
                if(parentElement.querySelector('.countryCodeSelector')) { 
                    self.loadRespectiveState({
                        loadedfrom: 'countryCodeDropdown',
                        parentElement: parentElement
                    });
                }
            }
        });

    },
    initCoutrySelection: function(countryDropdown, parentElement) {
        const self = this;

        countryDropdown.addEventListener('click', (event) => {
            const item = event.target.closest('.item');

            if (item && countryDropdown.contains(item)) {
                if(parentElement.querySelector('.custom-search-select.shipping-state-dropdown')) { 
                    self.loadRespectiveState({
                        loadedfrom: 'countryDropdown',
                        parentElement: parentElement
                    });
                }
            }
        });

    },
    loadRespectiveState: function({loadedfrom, parentElement}) {
        const self = this;
        const countrySelect = parentElement.querySelector('.shippingCountrySelect');
        const selectedCountryOption = countrySelect?.options[countrySelect.selectedIndex];
        const dataActionURL = countrySelect?.getAttribute("data-action-url");

        if (selectedCountryOption) {
            $.ajax({
                url: dataActionURL,
                data: {
                    selectedCountry: selectedCountryOption.id
                },
                success: function(data) {
                    const states = data.states;

                    if (states && states.length > 0) {
                        self.updateList(".shipping-state-dropdown", states, loadedfrom, parentElement);
                    }

                },
                error: function() {
                }
            });
        }
    }
}